const MAX_TIMEOUT_MS = 2147483647;

export const getBearerTokenFromHeaders = (headers) => {
  if (!headers) return null;
  const raw =
    (typeof headers.get === "function"
      ? headers.get("Authorization") || headers.get("authorization")
      : null) ||
    headers.Authorization ||
    headers.authorization;
  if (!raw) return null;
  return String(raw).replace(/^Bearer\s+/i, "").trim() || null;
};

export const isCurrentUserEndpoint = (url = "") => {
  const path = (() => {
    try {
      return new URL(url, "http://local.invalid").pathname || "";
    } catch (_) {
      return String(url);
    }
  })();
  return /(^|\/)auth\/me\/?$/.test(path);
};

/**
 * Destroy the session only when the server rejected the token that is
 * currently stored. A delayed 401 from an older login must not log out
 * a newer session. Permission 403s stay non-fatal, except GET /auth/me
 * which means this identity is no longer valid.
 */
export const shouldClearSessionOnUnauthorized = ({
  status,
  isPublicAuthEndpoint,
  requestToken,
  currentToken,
  requestUrl,
  requestMethod,
}) => {
  if (isPublicAuthEndpoint) return false;
  if (!currentToken || !requestToken || requestToken !== currentToken) {
    return false;
  }
  if (status === 401) return true;
  if (
    status === 403 &&
    String(requestMethod || "").toLowerCase() === "get" &&
    isCurrentUserEndpoint(requestUrl)
  ) {
    return true;
  }
  return false;
};

export const getTokenExpiryDelayMs = (expSeconds, nowMs = Date.now()) => {
  if (!expSeconds) return 0;
  return expSeconds * 1000 - nowMs;
};

export const getTimeoutDelayMs = (delayMs) =>
  Math.max(0, Math.min(delayMs, MAX_TIMEOUT_MS));
